export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Nossos módulos</h2>
          <p style={{ textAlign: "center" }}>
            Entre em contato para saber mais.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-md-4">
                  {" "}
                  <i className={d.icon} aria-hidden="true"></i>
                  <div className="service-desc">
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "Carregando..."}
        </div>
      </div>
    </div>
  );
};
